define([
    'lodash'
],
function (_) {
    'use strict';

    function UiStateApiCallMap(uiState) {
        const uiProps = UiStateApiCallMap.callByProperty();
        return _.reduce(uiState, function (callMap, value, property) {
            return _.assign(callMap, uiProps[property](value));
        }, {});
    }

    UiStateApiCallMap.callByProperty = function () {
        return {
            userFilter(filterModel) {
                return {setFilterModel: [filterModel]};
            }
        };
    };

    UiStateApiCallMap.uiProperties = ['userFilter'];

    UiStateApiCallMap.getUIStateProps = function (props) {
        return _.pick(props, UiStateApiCallMap.uiProperties);
    };

    return UiStateApiCallMap;
}
);
